import { TinyParcel } from '../types';
import { useCallback, useContext, useMemo } from 'react';
import { ParcelService } from '../services';
import { MeContext } from '@modules/me/context/context';
import { useQuery } from '@shared/modules/use-query/hooks';

export const useTinyParcels = () => {
  const { state: userState } = useContext(MeContext);

  return useQuery<TinyParcel[]>(
    useCallback(async () => {
      const result = await ParcelService.getAllTiny();

      if (result.status === 200) {
        return result.data;
      } else {
        throw new Error(result.data);
      }
    }, []),
    useMemo(() => ({ initialData: [], enabled: !!userState.user.data }), [userState.user.data]),
  );
};
